import React, { useEffect, useState } from 'react'
import InputCustom from '../../components/elements/InputCustom'
import SelectDropDown from '../../components/elements/SelectDropDown'
import TextAreaCustom from '../../components/elements/TextAreaCustom'
import AddFileScriptArchive from './AddFileScriptArchive'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang'
import AddProductionCrewScriptArchive from './AddProductionCrewScriptArchive'
import { VariableScriptsArchive } from './VariableScriptsArchive'
import { loadPageListScriptArchive, postScriptArchive } from '../../store/Actions/ActionScriptArchive'
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom'

function AddScriptsArchive() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { page_list_scripts_archive, loadingPageListScriptsArchive } = useSelectorCustom()
    const { translate } = AbstructLang()
    const { state, setStateCustom, setLoad } = VariableScriptsArchive();
    const [fields, setFields] = useState([{
        file_path: '',
        notes: '',
        type: '',
        descrptions: ''
    }])
    const [fieldsCrew, setFieldsCrew] = useState([{
        name: '',
        description: '',
        production_crew_id: '',
    }])
    const handleFieldChange = (name, value) => {
        setStateCustom(name, value)
    }
    useEffect(()=>{
        dispatch(loadPageListScriptArchive())
    },[])
    const send =()=>{
        const body ={
            name: state?.name,
            description: state?.description,
            status: state?.status,
            thumbnail: state?.thumbnail,
            creative_work_type_id: state?.creative_work_type_id,
            episodes_count: state?.episodes_count,
            duration_minutes: state?.duration_minutes,
            production_crews: fieldsCrew,
            files: fields
        }
        dispatch(postScriptArchive(body,setLoad))
    }
    return (
        <>
            <main>
                <div className='div_table margin_main shadow_main' >
                    <div className='AddScriptsArchive' dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                        <h3 >{translate('add_scripts_archive')}</h3>
                        <br></br>
                        <h4>{translate('basic_info')}</h4>
                        <br></br>
                        <div className='d-flex'>
                            <InputCustom
                                label='script_name'
                                iconType='pencil'
                                type='text'
                                onChange={(e) => setStateCustom('name', e.target.value)}
                            />
                            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`}>
                                <span>{translate('script_type')}</span>
                                <SelectDropDown
                                    options={page_list_scripts_archive?.creative_work_types?.map((type)=>({
                                        label: type?.type,value: type?.id
                                    }))}
                                    varr={state.creative_work_type_id}
                                    setVarr={(value) => setStateCustom('creative_work_type_id', value)}
                                />
                            </div>
                            <InputCustom
                                label='episodes_count'
                                iconType='pencil'
                                type='number'
                                onChange={(e) => setStateCustom('episodes_count', e.target.value)}
                            />
                            <InputCustom
                                label='film_duration'
                                iconType='pencil'
                                type='number'
                                onChange={(e) => setStateCustom('duration_minutes', e.target.value)}
                            />
                            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`}>
                                <span>{translate('status')}</span>
                                <SelectDropDown
                                    options={page_list_scripts_archive?.status?.map((statuss)=>({
                                        label: statuss,value: statuss
                                    }))}
                                    varr={state.status}
                                    setVarr={(value) => setStateCustom('status', value)}
                                />
                            </div>
                            <div className='w-25' >
                                <InputCustom
                                    label='thumbnail'
                                    iconType='pencil'
                                    type='file' service_name='SCRIPTS' typeFileOne
                                    onChange={handleFieldChange} name='thumbnail'
                                />
                            </div>
                            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-text-area`} style={{ width: '48%' }}>
                                <TextAreaCustom
                                    label='description'
                                    value={state.description}
                                    onChange={(e) => setStateCustom('description', e.target.value)}
                                    nameClass='textarea-gen'
                                />
                            </div>
                        </div>
                        <br></br>

                        <h4>{translate('production_crew')}</h4>
                        <br></br>
                        <AddProductionCrewScriptArchive page_list_scripts_archive={page_list_scripts_archive} fields={fieldsCrew} setFields={setFieldsCrew} />
                        <br></br>

                        <h4>{translate('files')}</h4>
                        <br></br>
                        <AddFileScriptArchive page_list_scripts_archive={page_list_scripts_archive} fields={fields} setFields={setFields} />
                        <br></br>

                        <button onClick={send} className='btn_top_table'>{translate('save')}</button>
                    </div>
                </div>
            </main>
        </>
    )
}

export default AddScriptsArchive